module.exports = __webpack_public_path__ + "static/media/forbes.2fa5fe09.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/forbes.png
// module id = 1789
// module chunks = 146